import { render, staticRenderFns } from "./LogoIcon.vue?vue&type=template&id=2e0473b2&scoped=true&"
import script from "./LogoIcon.vue?vue&type=script&lang=js&"
export * from "./LogoIcon.vue?vue&type=script&lang=js&"
import style0 from "./LogoIcon.vue?vue&type=style&index=0&id=2e0473b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0473b2",
  null
  
)

export default component.exports